import { inject, Injectable } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";
import { SnackbarComponent, SnackbarData, SnackbarType } from "./snackbar.component";

@Injectable({ providedIn: "root" })
export class SnackbarService {
    private readonly snackBar = inject(MatSnackBar);

    show(message: string, type: SnackbarType, duration = 5000, panelClass: string | string[] = []): void {
        this.snackBar.openFromComponent<SnackbarComponent, SnackbarData>(SnackbarComponent, {
            data: { message, type },
            duration,
            verticalPosition: "top",
            horizontalPosition: "center",
            panelClass: ["app-snackbar-panel", ...[panelClass].flat()]
        });
    }
}
